import type { ReactNode } from "react";

import { BorderedFrame } from "@/components/blocks/bordered-frame";
import type { RailConnectorEdge } from "@/components/blocks/bordered-frame";
import { cn } from "@/lib/utils";

interface BrokerPanelProps {
  children: ReactNode;
  className?: string;
  innerClassName?: string;
  /** Collapse the top border with the previous white panel (Figma stacked containers). */
  stack?: boolean;
  /** Grid-connector marks on the panel border (Figma page rail). */
  connectors?: "none" | "top" | "bottom" | "both";
  dataTestId?: string;
}

function mapConnectors(
  connectors: BrokerPanelProps["connectors"]
): RailConnectorEdge | "none" {
  switch (connectors) {
    case "top":
      return "rail-top";
    case "bottom":
      return "rail-bottom";
    case "both":
      return "rail-both";
    default:
      return "none";
  }
}

/** White bordered module container used across the brokers page (Figma 7793:34985). */
export function BrokerPanel({
  children,
  className,
  innerClassName,
  stack = false,
  connectors = "none",
  dataTestId,
}: BrokerPanelProps) {
  return (
    <section
      data-testid={dataTestId}
      className={cn("bg-grey-50 px-6 py-0 lg:px-20 lg:py-0", className)}
    >
      <BorderedFrame
        connectors={mapConnectors(connectors)}
        stack={stack}
        className={cn(
          "max-lg:border-0 max-lg:bg-transparent max-lg:px-0 max-lg:py-0",
          "px-6 md:px-12 lg:px-16",
          innerClassName
        )}
      >
        {children}
      </BorderedFrame>
    </section>
  );
}
